export interface MapTileConfig {
  readonly mapTileServiceBaseUrl: string;
  readonly mapTileLayerQueryParams: string;
  readonly mapTileAuthToken: string;
}

export function buildMapTileBaseUrl(config: MapTileConfig): string {
  return `${config.mapTileServiceBaseUrl}?X={x}&Y={y}&Z={z}&${config.mapTileLayerQueryParams}&authtoken=${config.mapTileAuthToken}`;
}
